export default function HorizontalBar() {
  return <div className="w-full my-6 bg-pri-gray-200 flex h-px"></div>;
}
